export const DEBUG_EVENT = 'from-client-frontend/debug-event';

export const debugEvent = ({ name, payload = {} }) => ({
  type: DEBUG_EVENT,
  payload: {
    name,
    eventPayload: payload,
    date: new Date().toString(),
    ts: +new Date()
  }
})
